import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/store';
Vue.use(Router);
var router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'calc',
    component: function component() {
      return import(
      /* webpackChunkName: "calc" */
      './Calc.vue');
    }
  }]
});

var waitForStorageToBeReady =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(to, from, next) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return store.restored;

          case 2:
            next();

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function waitForStorageToBeReady(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

router.beforeEach(waitForStorageToBeReady);
export default router;